import React, { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';

import { ListItemText, Menu, MenuItem, MenuList, Paper } from '@mui/material';
import {
  AddPredelTempSubscriptionModal,
  AddSubscriptionModal,
  CreateSubscriptionModal,
  PermissionsGate,
} from '@components';
import { IconButtonV2 } from 'components/common/ui';
import { ENTITIES_PERMISIONS } from 'components/common/PermissionsGate/constants';
import { Tooltip } from 'components/common/modals';
import { useToggleModal } from '@hooks';

const UserSubscriptionAddMenu = ({
  subscriber,
  userId,
  onGetUserSubscriptions,
}) => {
  const {
    isOpen: isOpenCreateSubscription,
    handleOpen: handleOpenCreateSubscription,
    handleClose: handleCloseCreateSubscription,
  } = useToggleModal();
  const {
    isOpen: isOpenAddSubscription,
    handleOpen: handleOpenAddSubscription,
    handleClose: handleCloseAddSubscription,
  } = useToggleModal();
  const {
    isOpen: isOpenAddPredelTempSubscription,
    handleOpen: handleOpenAddPredelTempSubscription,
    handleClose: handleCloseAddPredelTempSubscription,
  } = useToggleModal();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (item) => {
    item.onClick();

    handleMenuClose();
  };
  const options = [
    {
      label: 'Create Subscription',
      onClick: handleOpenCreateSubscription,
    },
    {
      label: 'Add Subscription',
      onClick: handleOpenAddSubscription,
    },
    {
      label: 'Add Predel/Temp Subscription',
      onClick: handleOpenAddPredelTempSubscription,
    },
  ];
  return (
    <>
      <PermissionsGate entity={ENTITIES_PERMISIONS.WriteSubscriptions}>
        <IconButtonV2 onClick={handleOpenMenu} variant="text" size="small">
          <Tooltip title="Add Subscriptions" placement="top">
            <AddIcon data-testid="AddIcon" fontSize="small" />
          </Tooltip>
        </IconButtonV2>
      </PermissionsGate>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{
          padding: 0,
        }}
      >
        <Paper
          sx={{
            maxWidth: '300px',
            padding: 0,
            width: '100%',
          }}
        >
          <MenuList
            sx={{
              padding: '4px',
              width: '100%',
              minWidth: '100px',
            }}
          >
            {options?.map((item) => {
              return (
                <MenuItem
                  key={item.label}
                  onClick={() => handleClick(item)}
                  sx={{
                    fontSize: '0.875rem',
                    padding: '8px 10px!important',
                    marginBottom: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    borderRadius: '8px',
                    color: (theme) => theme.palette.text.primary,
                    '&:hover': {
                      color: (theme) => theme.palette.text.primary,
                      backgroundColor: (theme) => theme.palette.grays?.gray100,
                    },
                  }}
                >
                  <AddIcon data-testid="AddIcon" fontSize="small" />
                  <ListItemText>{item.label}</ListItemText>
                </MenuItem>
              );
            })}
          </MenuList>
        </Paper>
      </Menu>
      {isOpenCreateSubscription && (
        <CreateSubscriptionModal
          subscriber={subscriber}
          userId={userId}
          getSubscriptions={onGetUserSubscriptions}
          onClose={handleCloseCreateSubscription}
          isOpen={isOpenCreateSubscription}
        />
      )}
      {isOpenAddPredelTempSubscription && (
        <AddPredelTempSubscriptionModal
          subscriber={subscriber}
          userId={userId}
          getSubscriptions={onGetUserSubscriptions}
          onClose={handleCloseAddPredelTempSubscription}
          isOpen={isOpenAddPredelTempSubscription}
        />
      )}
      {isOpenAddSubscription && (
        <AddSubscriptionModal
          subscriber={subscriber}
          userId={userId}
          getSubscriptions={onGetUserSubscriptions}
          onClose={handleCloseAddSubscription}
          isOpen={isOpenAddSubscription}
        />
      )}
    </>
  );
};

const memoizedUserSubscriptionAddMenu = React.memo(UserSubscriptionAddMenu);
export { memoizedUserSubscriptionAddMenu as UserSubscriptionAddMenu };

export default memoizedUserSubscriptionAddMenu;
